import React, { useEffect } from 'react';
import { Input, Form, DatePicker, Button, Row, Col, Icon, Dropdown, Menu, Divider, Select } from 'antd';
import { RemoveEmptyEle, removePropertyOfNull } from '../../../utils';
import { connect } from 'react-redux';
import { clientlistAc } from '../../../redux/actions';
import moment from 'moment';

const { RangePicker } = DatePicker;
const { Option } = Select;

const mapStateToProps = (state) => ({ state: state.clientRd });

const mapDispatchToProps = (dispatch) => ({ set: (value) => dispatch(clientlistAc.SET(value)) });

const SearchItems = connect(mapStateToProps, mapDispatchToProps)(Form.create()(
	function SearchItems({ form, onFinish, state }) {
		const formLargeItemLayout = { labelCol: { span: 4 }, wrapperCol: { span: 18 } };

		const handleSubmit = (e) => {
			e.preventDefault();
			form.validateFields((err, values) => {
				if (!err) {
					onFinish(removePropertyOfNull(values));
				}
			});
		}
		const buttonItemLayout = {
			wrapperCol: { span: 24 },
		};
		const reset = () => {
			form.resetFields();
		};
		return (
			<Form {...formLargeItemLayout}>
				<Row gutter={24} style={{ marginBottom: '12px' }}>
					<Col span={3}>
						<Form.Item label="产品" style={{ fontSize: '14px' }}>
							{form.getFieldDecorator('guarantee_type', { initialValue: '0' })(
								<Select style={{ width: '100%', color: 'blue' }}>
									<Option key="0" value="0">企信宝</Option>
									<Option key="1" value="1">大经宝</Option>
								</Select>
							)}
						</Form.Item>
					</Col>
					<Col span={5}>
						<Form.Item label="客户">
							{form.getFieldDecorator('cust_name', {})(<Input placeholder="客户名称" />)}
						</Form.Item>
					</Col>
					<Col span={5}>
						<Form.Item label="标记">
							{form.getFieldDecorator('guarantee_status', {})(
								<Select placeholder="状态">
									<Option key="1" value="">全部</Option>
									<Option key="2" value="1">标记</Option>
									<Option key="3" value="0">未标记</Option>
								</Select>
							)}
						</Form.Item>
					</Col>
					<Col span={6}>
						<Form.Item label="审核日期">
							{form.getFieldDecorator('approver_time', {})(
								<RangePicker showTime={{ defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('00:00:00', 'HH:mm:ss')] }} />
							)}
						</Form.Item>
					</Col>
					{state.optionalSearchItems.addedExtraItems &&
					state.optionalSearchItems.addedExtraItems.map(item => (
						<Col span={3} key={item.formFieldName}>
							<Form.Item label={item.title}>
								{form.getFieldDecorator(item.formFieldName, {})(item.element)}
							</Form.Item>
						</Col>
					))}

				</Row>
				<Row gutter={24} style={{ marginBottom: '12px' }}>
					<Col span={24}>
						<Form.Item {...buttonItemLayout}>
							<Button type="primary" onClick={handleSubmit} style={{ marginRight: 8 }}>
								<Icon type="search" /> 查询
							</Button>
							<Button type="default" onClick={reset}>
								<Icon type="redo" /> 重置
							</Button>
						</Form.Item>
					</Col>
				</Row>
			</Form>
		);
	}
));

const DropAdd = connect(mapStateToProps, mapDispatchToProps)(
	function DropAdd({ set, state }) {
		useEffect(() => {
			set({
				optionalSearchItems: {
					extraItems: [
						{ title: "状态", formFieldName: "status", element: (<Input placeholder="状态" />) },
						{ title: "SAP编码", formFieldName: "sap_no", element: (<Input placeholder="SAP编码" />) },
					],
					addedExtraItems: []
				}
			});
		}, []);

		return (
			<>
				<Divider type="vertical" />
				<Dropdown overlay={
					<Menu>
						{state.optionalSearchItems.extraItems && state.optionalSearchItems.extraItems.map((item, i) => (
							<Menu.Item key={item.title} onClick={() => {
								const newExtraItems = [...state.optionalSearchItems.extraItems];
								const clickedItem = newExtraItems.splice(i, 1)[0];
								set({
									optionalSearchItems: {
										extraItems: newExtraItems,
										addedExtraItems: [...state.optionalSearchItems.addedExtraItems, clickedItem],
									}
								})
							}}>
								{item.title}
							</Menu.Item>
						))}
					</Menu>
				}>
					<Button>
						添加更多搜索项 <Icon type="down" />
					</Button>
				</Dropdown>
			</>
		);
	}
);

export { DropAdd, SearchItems };
